import log from '@uwm/logger';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {selectIsInitialized} from '@/state/selectors/uwm';

export const useInitModule = () => {
    const isInitialized = useSelector(selectIsInitialized);

    useEffect(() => {
        if (!isInitialized) return;

        log.info('[ExperienceScore] Module initialized, waiting for inference data...');
    }, [isInitialized]);
};
